// extracted by mini-css-extract-plugin
module.exports = {"NewGameButtons":"gameControls_NewGameButtons__1CagB"};